export default "__VITE_ASSET__76e95556__"